import React from 'react';
import { string, bool, node } from 'prop-types';
import Modal, { OpenModalButton } from '../Modal';
import FullscreenModal from '../Modal/fullscreen-modal';

const ZoomContainer = (props) => {
  return (
    <div className="zoom-container">
      <Modal fullScreen={props.fullScreen}>
        <OpenModalButton
          id={`zoom-modal-${props.id}`}
          className="zoom-fullscreen__modal-open"
        >
          {props.OpenZoomButtonText && (
            <span className={props.showOpenModalText ? null : 'show-for-sr'}>
              {props.OpenZoomButtonText}
            </span>
          )}
        </OpenModalButton>
        <FullscreenModal
          id={`zoom-modal-${props.id}`}
          classModifier="zoom-fullscreen"
          showCloseModalText={props.showCloseModalText}
        >
          {props.children}
        </FullscreenModal>
      </Modal>
      {props.children}
    </div>
  );
};

ZoomContainer.propTypes = {
  /** Show the open modal button text or not.
   *  Will still be visible to screenreaders if set to false
   */
  showOpenModalText: bool,
  /** Show the close modal button text or not
   *  Will still be visible to screenreaders if set to false
   */
  showCloseModalText: bool,
  /** Body of the content */
  children: node,
  /** If you want the zoomcontent to be fullscreen or not */
  fullScreen: bool,
  /** The component id, used to identify which component to open */
  id: string,
  /** Button text for the open modal button */
  OpenZoomButtonText: string
}

export default ZoomContainer;
